import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import type { RouteObject } from 'react-router-dom';

const DraftsListPage = Loadable(lazy(() => import('./components/DraftsListPage')));

/**
 * This feature's own routes, composed into the app router by whichever legacy route file
 * still owns this path prefix — src/routes/AuthenticatedRoutes.jsx today, src/app/router.tsx
 * once that exists (AGENTS.md §1). Mirrors features/shipments/routes.tsx and
 * features/quotes/routes.tsx.
 */
export const draftsRoutes: RouteObject[] = [
  {
    path: '/shipments/drafts',
    element: <DraftsListPage />
  }
];
